import React, { useEffect, useState } from "react";
import {
  ConnectAccountOnboarding,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js";
import useStripeConnect from "../../../../hooks/useStripeConnect";
import backend from "../../../../api";
import { useSelector } from "react-redux";
import SubmitButton from "../../../common/buttons/SubmitButton";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

// const accountId = "acct_1QPl1HBDzq8OWgqB"; // for dummy purpose only need to make dynamic

const ConnectOnboard = ({ accountId, id }) => {
  const { user } = useSelector((state) => state.auth);
  // const [connectedAccountId, setConnectedAccountId] = useState("");
  // const [account_Id, setAccount_Id] = useState(id || "");
  // const { stripeConnectInstance, instanceLoading } = useStripeConnect(
  //   connectedAccountId
  // );

  const [accountCreatePending, setAccountCreatePending] = useState(false);
  const [error, setError] = useState(false);
  // const [onboardingExited, setOnboardingExited] = useState(false);
  // const [loading, setLoading] = useState(true);
  const history = useHistory();

  const createConnectedAccount = async () => {
    setAccountCreatePending(true);
    try {
      const response = await backend.post("/connected-account/create", {
        userId: user?.user?._id,
      });

      const { account, error, account_id } = response?.data;

      if (account) {
        console.log("response?.data: ", response?.data);
        // setConnectedAccountId(account);
        history.push(`/complete-onboard/bank-accout/${account}/${account_id}`);
      }

      if (error) {
        console.log("error inside the Try: ", error);
        setError(true);
      }
    } catch (error) {
      setError(true);
      console.log("error: ", error?.response);
      console.log("error: ", error);
    } finally {
      setAccountCreatePending(false);
    }
  };

  // const onLoadError = (loadError) => {
  //   const componentName = loadError.elementTagName;
  //   const error = loadError.error;
  //   console.log(componentName + " failed to load");
  //   console.log(`${error.type}: ${error.message}`);
  // };

  // const onLoaderStart = (event) => {
  //   setLoading(false);
  // };

  // const onExit = async (event) => {
  //   console.log("event: ", event);
  //   setOnboardingExited(true);
  //   history.push(
  //     `/view-account/bank-account/${connectedAccountId}/${account_Id}`
  //   );
  // };

  return (
    <div>
      <SubmitButton
        onClick={createConnectedAccount}
        isSubmitting={accountCreatePending}
      >
        Get Started
      </SubmitButton>
      {error && <p className="error">Something went wrong!</p>}
      {/* {connectedAccountId ? (
        instanceLoading ? (
          "Loading"
        ) : (
          <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
            <ConnectAccountOnboarding
              onExit={onExit}
              onLoadError={onLoadError}
              onLoaderStart={onLoaderStart}
              collectionOptions={{
                fields: "eventually_due",
                futureRequirements: "include",
              }}
              onStepChange={(stepChange) => {
                console.log(`User entered: ${stepChange.step}`);
              }}
            />
          </ConnectComponentsProvider>
        )
      ) : (
        <>
          <SubmitButton
            onClick={createConnectedAccount}
            isSubmitting={accountCreatePending}
          >
            Get Started
          </SubmitButton>
          {error && <p className="error">Something went wrong!</p>}
        </>
      )} */}
    </div>
  );
};

export default ConnectOnboard;
